import React from 'react';

const MastercardIcon: React.FC<{className?: string}> = ({ className = "w-12 h-8" }) => (
  <svg className={className} viewBox="0 0 48 32" fill="none">
    <rect width="48" height="32" rx="4" fill="white"/>
    <circle cx="19" cy="16" r="10" fill="#EB001B"/>
    <circle cx="29" cy="16" r="10" fill="#F79E1B"/>
    <path d="M24 16C24 12.7 26.7 10 30 10C28.3 10 26.8 10.8 26 12.1C25.2 10.8 23.7 10 22 10C18.7 10 16 12.7 16 16C16 19.3 18.7 22 22 22C23.7 22 25.2 21.2 26 19.9C26.8 21.2 28.3 22 30 22C26.7 22 24 19.3 24 16Z" fill="#FF5F00"/>
  </svg>
);

export default MastercardIcon; 